import { atom } from "recoil";

import { InitialParameters, User } from "../types/index";
import { APPLICATION_VERSION, LOCAL_STORAGE_KEY } from "../utils/variables";
export const appVersion = APPLICATION_VERSION;

const defaultPrameters: InitialParameters = {
  workerSingleForInput: null,
  workersForMultiInput: [],
  workersForList: [],
  factoryNo: [51],
  factoryNoForSingleInput: 51,
  factoryNoForMultiInput: 51,
  productNo: "",
  productBno: "",
  productNoForSingleInput: "",
  productBnoForSingleInput: "",
  productNoForMultiInput: "",
  productBnoForMultiInput: "",
  latestUrl: "/",
  // construction: 5,
  // constructionForSingleInput: 5,
  // constructionForMultiInput: 5,
  slipNumberForSingleInput: "0000000",
  slipNumberForMultiInput: "0000000",
  isShowSlipNumber: false,
  productNoForMatrix: "",
  productBnoForMatrix: "",
  // constructionForMatrix: 5,
  wokerIdForMatrix: "",
  factoryNoForMatrix: 51,
  isPinned: true,
  zoomLevel: "1",
};
const defaultUser: User = {
  appVersion: appVersion,
  workerId: null, //社員番号-未使用
  mail: null, //メールアドレス
  photoURL: null, //写真URL
  workerName: null, //社員名
  isAuth: false, //認証
  initialParameters: defaultPrameters,
};
const initializeUserFromLocalStrage = () => {
  const storedUser = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (storedUser) {
    try {
      const userObject = JSON.parse(storedUser);
      // console.log("userObject", userObject, appVersion, userObject.appVersion);
      if (userObject.appVersion !== appVersion) {
        localStorage.clear();
        return defaultUser;
      }
      return userObject;
    } catch (error) {
      console.error("Parsing error", error);
      return defaultUser; // パースに失敗した場合のデフォルト値
    }
  } else {
    return defaultUser; // LocalStorageにデータがない場合のデフォルト値
  }
};
export const userState = atom({
  key: "userState",
  default: initializeUserFromLocalStrage(),
});
